// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"styles_priceContainer__1_Ufj","price":"styles_price__3M3Sv"};